import { Navigate, Route, Routes } from "react-router-dom";
import ChatAssistant from "./ChatAssistant";
import PatchAssistant from "./PatchAssistant";

const Assistant = () => (
  <Routes>
    <Route index element={<Navigate to="chat-assistant" />} />

    <Route path="chat-assistant" element={<ChatAssistant />} />
    <Route path="patch-assistant" element={<PatchAssistant />} />
  </Routes>
);

export default Assistant;
